import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import customStatusActions, { customStatusActionTypes } from '../../actions/configurations/customStatusActions';
import CustomStatusServices from '../../services/configurations/customStatusServices';

function* _createCustomStatus(action) {
  try {
    const { payload } = action;
    yield put(customStatusActions.createCustomStatusLoading(true));
    const customStatus = yield CustomStatusServices.createCustomStatus(payload);
    if (customStatus.success) {
      notification.open({
        type: 'success',
        message: 'Custom Status successfully created',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(customStatus);
      }
      yield put(customStatusActions.createCustomStatusLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: customStatus?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(customStatusActions.createCustomStatusLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(customStatusActions.createCustomStatusLoading(false));
  }
}

function* createCustomStatus() {
  yield takeLatest(customStatusActionTypes.CREATE_CUSTOM_STATUS.REQUEST, _createCustomStatus);
}

function* _updateCustomStatus(action) {
  try {
    yield put(customStatusActions.updateCustomStatusLoading(true));
    const customStatus = yield CustomStatusServices.updateCustomStatus(action.payload);
    if (customStatus.success) {
      notification.open({
        type: 'success',
        message: 'Custom Status successfully updated',
        duration: 4,
        placement: 'top',
      });
      action.callback();
      yield put(customStatusActions.updateCustomStatusLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: customStatus?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(customStatusActions.updateCustomStatusLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(customStatusActions.updateCustomStatusLoading(false));
  }
}

function* updateCustomStatus() {
  yield takeLatest(customStatusActionTypes.UPDATE_CUSTOM_STATUS.REQUEST, _updateCustomStatus);
}

function* _getCustomStatus(action) {
  const {
    payload, callback,
  } = action;
  try {
    customStatusActions.getCustomStatusSuccess(null);
    yield put(customStatusActions.getCustomStatusLoading(true, payload?.entityName));
    const customStatus = yield CustomStatusServices.getCustomStatus(payload?.orgId, payload?.entityName);
    yield put(customStatusActions.getCustomStatusSuccess(customStatus?.data, payload?.entityName));
    if (callback) action.callback(customStatus);
    yield put(customStatusActions.getCustomStatusLoading(false, payload?.entityName));
  } catch (error) {
    yield put(customStatusActions.getCustomStatusLoading(false, payload?.entityName));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* getCustomStatus() {
  yield takeLatest(customStatusActionTypes.GET_CUSTOM_STATUS.REQUEST, _getCustomStatus);
}

function* _getOrgStatus(action) {
  const {
    payload, callback,
  } = action;
  try {
    customStatusActions.getOrgStatusSuccess(null);
    yield put(customStatusActions.getOrgStatusLoading(true, payload?.entityName));
    const customStatus = yield CustomStatusServices.getOrgStatus(payload?.orgId, payload?.entityName, payload?.orderType);
    yield put(customStatusActions.getOrgStatusSuccess(customStatus?.data, payload?.entityName));
    if (callback) action.callback();
    yield put(customStatusActions.getOrgStatusLoading(false, payload?.entityName));
  } catch (error) {
    yield put(customStatusActions.getOrgStatusLoading(false, payload?.entityName));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* getOrgStatus() {
  yield takeLatest(customStatusActionTypes.GET_ORG_STATUS.REQUEST, _getOrgStatus);
}

function* _deleteCustomStatus(action) {
  try {
    yield put(customStatusActions.deleteCustomStatusLoading(true));
    const {
      payload, callback,
    } = action;
    const deletedCustomStatus = yield CustomStatusServices.deleteCustomStatus(payload);

    if (deletedCustomStatus.success) {
      notification.open({
        type: 'success',
        message: 'Custom Status successfully deleted',
        duration: 4,
        placement: 'top',
      });
      callback();
    } else {
      notification.open({
        type: 'error',
        message: deletedCustomStatus?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(customStatusActions.deleteCustomStatusLoading(false));
  } catch (error) {
    yield put(customStatusActions.deleteCustomStatusLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* deleteCustomStatus() {
  yield takeLatest(customStatusActionTypes.DELETE_CUSTOM_STATUS.REQUEST, _deleteCustomStatus);
}

export default function* customStatusSaga() {
  yield all([
    createCustomStatus(), getCustomStatus(), updateCustomStatus(), deleteCustomStatus(), getOrgStatus(),
  ]);
}
